import React, { Component } from 'react';
import Poster from '../../assets/img/Grand_Seminar.jpg';
import './Seminar.css'

class Seminar extends Component{
    render() {
        return (
            <div className="main">
                <img src={Poster} className="Poster"/>
            </div>
        )
    }
}

export default Seminar